import React, { useEffect, useState, useContext, useRef, useMemo } from "react";
import { Card } from 'primereact/card';
import { Skeleton } from 'primereact/skeleton';
import { useWeb3React } from "@web3-react/core";
import Web3 from "web3";
import { Button } from 'primereact/button';
import { Toast } from 'primereact/toast';
import { InputNumber } from "primereact/inputnumber";
import { InputText } from 'primereact/inputtext';
import { Grid, Input as NextInput, Loading } from '@nextui-org/react';
import { Progress } from '@nextui-org/react';
import { Slider } from 'primereact/slider';
import { Message } from 'primereact/message';


import ContractContext from '../../ContractContext'; //Required for all dApp components using contracts

import { formatDecimals, formatCurrencyExtended, formatWalletAddress, getTokenPrice, getTokenDecimals, formatTokenIcon, formatPercentage, formatBalanceWithIcon } from '../../utils';
import { miniCardHeaderStyle, miniInfoStyle, cardHeaderStyle, cardOutlineHeaderStyle, cardOutlineExtendedStyle, cardStyle, infoOutlineStyle } from "./TileStyles";

import { getGradientCardStyle } from "./TileStyles";
import rocketfiIcon from "../../imgs/rocketfi_yellow_token.png";
import smartChainIcon from "../../imgs/smartchain.png";
import BigNumber from 'bignumber.js'
import { width } from "@mui/system";
import { get } from "https-browserify";

const DashboardSwap = ({ data, getData, bnbBalance, smartCodeData}) => {

    const { library, account } = useWeb3React();
    const contractContext = useContext(ContractContext);
    const contracts = contractContext.contracts;
    const isWalletConnected = () => account !== null;
    const rocketFiPrice = getTokenPrice(data.tokensList, "ROCKETFI");
    const [smartCode, setSmartCode] = useState('');
    const [isValid, setIsValid] = useState(false);

    const [lastBuy, setLastBuy] = useState();
    const [payItForwardData, setSwapData] = useState();

   
    

    const toast = useRef(null);

    const tokenPrice = (token) => data.pricingData[token.toLowerCase()].usd;
    const tokenDecimals = (token) => data.dbData.find(dbToken => dbToken.address.toLowerCase() === token.toLowerCase()).decimals;
    const tokenSymbol = (token) => data.dbData.find(dbToken => dbToken.address.toLowerCase() === token.toLowerCase()).symbol;

    const [instantSwapClicked, setInstantSwapClicked] = useState(false);
    const [previousWinner, setPreviousWinner] = useState(null);
    const [bnbPrice, setBnbPrice] = useState(null);

    const [tokenIn, setTokenIn] = useState("0xbb4CdB9CBd36B01bD1cBaEBF2De08d9173bc095c");
    const [tokenOut, setTokenOut] = useState("0x6e61579c22F9a6dA63a33e819f29B6697d2a126E");
    const [fee, setFee] = useState( data?.contractData?.tokenData?.rocketFiBuyFee ? data?.contractData?.tokenData?.rocketFiBuyFee : 0);

    const [isSwapping, setIsSwapping] = useState(false);

    
    const getRocketFiOut = async (bnbValue) => {
        if (!contracts.rocketSwapperLegacy) {
            //console.error("RocketSwapper contract not available.");
            return;
        }
        const value = new BigNumber(bnbValue).times(10 ** 18);

        try {
            const _rocketFiOut = await contracts.rocketSwapperLegacy.methods.getAmountOutMin(tokenIn, tokenOut, value.toString()).call();
            //console.log("rocketFiOut:", _rocketFiOut);
            return _rocketFiOut;
        } catch (error) {
            console.error("Error interacting with the Rocket Swapper contract:", error);
        }
    };

    useEffect(() => {
        // Check if data is loaded and if so update previous winner
        if (data && data.contractData && data.contractData.playData) {
            setPreviousWinner(data.contractData.playData.lastBuyBoostWinner);
        }
        setBnbPrice(getTokenPrice(data.tokensList, "WBNB"));
        //console.log("data:", data);
    }, [data]);

    useEffect(() => {
       // console.log("bnbBalance:", bnbBalance); 
    }, [bnbBalance]);

    useEffect(() => {
        //console.log("bnbPrice:", bnbPrice);
    }, [bnbPrice]);

    useEffect(() => {
        if (instantSwapClicked && data && data.contractData && data.contractData.playData) {
            if (account && data.contractData.playData.lastBuyBoostWinner === account
                && data.contractData.playData.lastBuyBoostWinner !== previousWinner) { // Check if the previous winner is not the current account
                const wonAmount = formatDecimals(data.contractData.playData.lastBuyBoostWinner, 9);
                toast.current.show({
                    severity: 'success',
                    summary: 'Congrats!',
                    detail: `You earned ${wonAmount} Buy Rewards! 🎉`,
                    life: 5000
                });
            } else {
                toast.current.show({
                    severity: 'info',
                    summary: 'Oh Snap!',
                    detail: 'No Buy Rewards Claimed! Try Again 🔥',
                    life: 5000
                });
            }
            setInstantSwapClicked(false);
        }
    }, [data, account, instantSwapClicked, previousWinner]);

    const [swapper, setSwapper] = useState(contracts?.rocketSwapperLegacy?._address ? contracts?.rocketSwapperLegacy?._address : "0xEF09d18e7fc101B3d6985Fe7b0277B7DF5db450A");
    const handleSwap = async (bnbAmount) => {
        setIsSwapping(true);
        if (!isWalletConnected()) {
            return;
        }
        if (!contracts.rocketSwapper) {
            return;
        }
        if (swapper === null || swapper === undefined || swapper === '' || swapper === '0x0000000000000000000000000000000000000000'
            ) {
            return;
        }

        try {
            //const transaction = contracts.rocketSwapper.methods.rocketSwapper().send({ from: account });
            //send 0.15 ETH to the rocketSwapper contract from account
            const web3 = new Web3(window.ethereum);
            //console.log("contracts.rocketSwapper.address :", contracts.rocketSwapper._address);
            //console.log("contracts.rocketSwapper :", contracts.rocketSwapper);

            //estimate gas first before sending transaction
            // const gas = await web3.eth.estimateGas({
            //     from: account,
            //     to: swapper,
            //     value: value
            // });
            
            const transaction = web3.eth.sendTransaction({ from: account, value: Web3.utils.toWei(bnbAmount, "ether") , to: swapper });
            /*sendTransaction({
                from: selectedAccount,
                to: swapperAddress,
                value: web3.utils.toWei(amount, "ether"),*/


            transaction.on("transactionHash", (hash) => {
                toast.current.show({ severity: 'info', summary: 'Transaction Submitted', detail: `Transaction Hash: ${hash}. Follow the transaction on BscScan here: https://bscscan.com/tx/${hash}`, life: 3000 });
            });

            const tx = await transaction;

            toast.current.show({ severity: 'success', summary: 'Transaction Success', detail: 'The transaction has been completed successfully. You earned a Boost Pool Multiplier!', life: 3000 });

            setInstantSwapClicked(true);
            setSmartCode('');
            getData();
            setIsSwapping(false);
            return true;
            
        } catch (error) {
            console.error("Error interacting with the Rocket Swapper contract:", error);
            toast.current.show({ severity: 'error', summary: 'Transaction Error', detail: `Error interacting with the Rocket Swapper contract: ${error.message}`, life: 3000 });
            getData();
            setIsSwapping(false);
            return false;
        }
        
        
    };


    const getSwapData = async () => {
        if (!contracts.rocketSwapper) {
            //console.error("RocketSwapper contract not available.");
            return;
        }

        try {
            const _totalBuys = await contracts.rocketSwapper.methods.totalBuys().call();
            const _lastBuy = await contracts.rocketSwapper.methods.buys(parseInt(_totalBuys) - 1).call();
            //console.log("lastBuy:", _lastBuy);
            setLastBuy(_lastBuy);
        } catch (error) {
            setLastBuy(null);
            console.error("Error interacting with the Rocket Swapper contract:", error);
        }
    };

    useEffect(() => {
        getSwapData();
        //console.log("data:", data);
    }, [data]);


    const swapCardStyle = getGradientCardStyle(rocketfiIcon, 'auto, auto 140%, auto', "rgb(51, 107, 187, 0.91)", "rgba(107, 107, 187, 0.9)");



    


    return (
        data &&
        <Card title={<div style={infoOutlineStyle}><strong>Rocket Swap</strong></div>} style={swapCardStyle}>
            <br />
            Buy RocketFi and potentially earn swap rewards! <br />
            {/* Enter a SmartCode for an additional tax discount. Share your smart code to qualify to earn on referral swaps.<br /><br /> */}

            <div style={{ marginTop: '10px' }} />
            <Card 
                style={cardStyle}>

                <TokenInput 
                                imageSrc={smartChainIcon} 
                                imageSrcTo={rocketfiIcon}
                                maxDecimalPlaces={18} 
                                maxNumbersToLeft={26}
                                step={1}
                                bnbPrice={bnbPrice}
                                rocketFiPrice={rocketFiPrice}
                                bnbBalance={bnbBalance}
                                handleSwap={handleSwap}
                                isSwapping={isSwapping}
                                data={data}
                                getRocketFiOut={getRocketFiOut}
                                fee={fee}
                                setFee={setFee}
                                smartCode={smartCode}
                                setSmartCode={setSmartCode}
                                isValid={isValid}
                                setIsValid={setIsValid}
                                setSwapper={setSwapper}
                                swapper={swapper}
                                smartCodeData={smartCodeData}
                            />
            </Card>

         
            <Toast ref={toast} />
        </Card>
    );
}

export default DashboardSwap;

const TokenInput = ({ 
    maxDecimalPlaces = 2, 
    maxNumbersToLeft = 5,
    minValue = 0, 
    maxValue = 999999999,
    step = 1,
    imageSrc,
    imageSrcTo,
    altText = "token-image",
    bnbPrice,
    rocketFiPrice,
    bnbBalance,
    handleSwap,
    isSwapping,
    data,
    getRocketFiOut,
    fee,
    setFee,
    smartCode, setSmartCode,
    isValid, setIsValid,
    setSwapper, swapper,
    smartCodeData
  }) => {
    const { library, account } = useWeb3React();
    const [value, setValue] = useState('');
    const [tokensOut, setTokensOut] = useState(0); 
    const [displayValue, setDisplayValue] = useState('');

    const contractContext = useContext(ContractContext);
    const contracts = contractContext.contracts;

    const rewardCardStyle = getGradientCardStyle(imageSrcTo, 'auto, auto 110%, auto', "black", "black");

    const LoadingTitle = () => <Skeleton width="70%" height="25px" className="mb-2" />;
    const LoadingContent = () => <Skeleton width="100%" height="35px" className="mb-2" />;

    const handleChange = (e) => {
        let inputValue = e.target.value.replace(/,/g, '');
    
        if (inputValue === '') {
            setValue('');
            setDisplayValue('');
            return;
        }
    
        if (!isNaN(inputValue) || inputValue.endsWith('.')) {
            const parts = inputValue.split('.');
            const leftOfDecimal = parts[0];
            const rightOfDecimal = parts[1] || '';
    
            if (leftOfDecimal.length <= maxNumbersToLeft && rightOfDecimal.length <= maxDecimalPlaces) {
                const numericValue = parseFloat(inputValue);
                if ((numericValue >= minValue && numericValue <= maxValue) || inputValue.endsWith('.')) {
                    setValue(inputValue);
                    setDisplayValue(inputValue);  // Note that we set the displayValue to be the inputValue directly
                }
            }
        }
    };

    useEffect(() => {
        if (value) {  
            getRocketFiOut(value).then((rocketFiOut) => {
                setTokensOut(rocketFiOut);
            });
        }
    }, [value]);


    const tokensOutWithTokenomics = tokensOut * (1 - fee / 10000);
    

    const handleStep = (direction) => {
        const numericValue = parseFloat(value || 0);
        const newValue = direction === "up" ? numericValue + step : numericValue - step;

        if (newValue >= minValue && newValue <= maxValue) {
            setValue(newValue.toString());
            setDisplayValue(newValue.toLocaleString('en-US', {
                maximumFractionDigits: maxDecimalPlaces,
                minimumFractionDigits: 0,
            }));
        }
    };

    const [direction, setDirection] = useState(null);
  
    useEffect(() => {
        if (direction) {
            const stepTimeoutId = setTimeout(() => {
                const stepIntervalId = setInterval(() => handleStep(direction), 100);
                return () => clearInterval(stepIntervalId);  // Cleanup the interval on unmount
            }, 500);
            
            return () => clearTimeout(stepTimeoutId);  // Cleanup the timeout on unmount
        }
    }, [direction]);

    const getIsRegistered = async (smartCode) => {
        const result = await contracts.smartCodes.methods.checkIsRegistered(smartCode).call();
        //console.log("getIsRegistered for", smartCode, ":", result);
        return result;
      }

      const getSwapperAddress = async (smartCode) => {
        const result = await contracts.smartCodes.methods.getHolderBySmartCode(smartCode).call();
        const result2 = await contracts.smartCodes.methods.ownerToProxy(result).call();
        return result2;
        }


    
    const handleSmartCodeInputChange = (e) => {
        const value = e.target.value.toUpperCase();
        setSmartCode(value);
      }

      useEffect(() => {
        if (smartCode && smartCode !== '') {
            getIsRegistered(smartCode)
                .then(result => {
                   // console.log("result:", result)
                    if(result === true) {
                        setIsValid(true);
                        return;
                    }
                    if(result === false) {
                        setIsValid(false);
                        return;
                    }
                })
                .catch(error => {
                   // console.log('Error:', error);
                });
        } else {
            setIsValid(false);
        }
    }, [smartCode]);


    useEffect(() => {
        if(isValid === true) {
            //console.log("smartCode is valid");
            setFee(266);
            getSwapperAddress(smartCode)
                .then(result => {
                    setSwapper(result);
                })
                .catch(error => {
                   // console.log('Error:', error);
                    //set to default swapper
                    setFee(data?.contractData?.tokenData?.rocketFiBuyFee);
                    setSwapper(contracts?.rocketSwapperLegacy?._address);
                }
            );
            return;
        }
      //  console.log("smartCode is not valid"); 
        setFee(data?.contractData?.tokenData?.rocketFiBuyFee);
        setSwapper(contracts?.rocketSwapperLegacy?._address);
    }, [isValid]);

    useEffect(() => {
       // console.log("swapper updated:", swapper);
    }, [swapper]);

    return (
        <>
        <div
        // style={{ 
        //     display: 'flex', 
        //     flexDirection: 'column', 
        //     alignItems: 'center', 
        //     width: '100%', 
        //     marginTop: '10px',
        //     overflow: 'hidden',  // Prevents overflow
        //     backgroundColor: 'black',
        //     borderRadius: '25px',
        //     //padding: '10px'
            
        // }}
        >
            {/* Main Row Container: Image + Input and Select Token */}
            <div style={{...miniCardHeaderStyle, marginBottom: '5px'}}>
                Token In
            </div>
            <div style={{
                display: 'flex', 
                flexDirection: 'row', 
                alignItems: 'center', 
                justifyContent: 'space-between', 
                width: '100%',
                //border: '1px solid black',
                borderRadius: '25px',
                backgroundColor: 'black',
                padding: '15px',
                overflow: 'hidden'  // Prevents overflow
            }}>
                {/* Left Container: Image + Input */}
                <div style={{flex: 0.75, paddingRight: '5px'}}> {/* Added flex and padding */}
                <div style={{ display: 'flex', flexDirection: 'row', alignItems: 'center',  position: 'relative'}}>
                    <div>
                        <img src={imageSrc} alt={altText} style={{ width: '40px', height: '40px', marginRight: '5px', border: '2px solid white', borderRadius: '50%'
                        }} />
                        {/* <img src={imageSrc} alt={altText} style={{ position: 'absolute', bottom: '0', left: '0', width: '25px', height: '25px', border: '2px solid white', borderRadius: '50%'}} /> */}
                    </div>
                    <div style={{ position: 'flex', flexDirection: 'column', alignItems: 'flex-start', flex: 1, width: '100%'}}>
                    <input type="text" value={displayValue} onChange={handleChange} placeholder="Amount"
                            style={{ width: '100%', border: 'none', outline: 'none', backgroundColor: 'transparent', fontSize: '18px', fontWeight: '100', color: 'white'}} />
                                    <div style={{ marginTop: '1px', padding: '1px', fontSize: '14px', fontWeight: 'normal', color: 'grey' }}>
                           {formatCurrencyExtended((value) * bnbPrice)}
                        </div>
                        </div>
                </div>

                

                </div>
                {/* Right Container */}
                
                <div style={{
                    display: 'flex',
                    flexDirection: 'column',
                    alignItems: 'flex-end',
                    flex: 0.25,  // takes up 50% of the space
                }}>
                    {/* Select Token Button */}
                    <div style={{ display: 'flex', flexDirection: 'column', justifyContent: 'flex-end', alignItems: 'flex-end', width: '100%', marginTop: '5px' }}>
                    <Button
                        rounded
                        severity="warning"
                        //onClick={() => setTokenSelectorVisible(true)}
                        size="small"
                        outlined
                        style={{
                            borderRadius: '25px',
                            paddingBottom: '2px',
                            paddingTop: '2px',
                            paddingLeft: '8px',
                            paddingRight: '8px',
                            fontSize: '14px',
                            fontWeight: 'bold',
                        }}
                    >
                        BNB
                    </Button>
                    <div style={{ marginTop: '2px', padding: '2px', fontSize: '14px', fontWeight: '100', color: 'grey', 
                    width: '100%', textAlign: 'right'
                }}>
                            Bal: {formatDecimals(bnbBalance, 18)}
                        </div>
                    </div>
                    {/* Token Balance + Max Button */}
                    <div style={{ display: 'flex', flexDirection: 'row', justifyContent: 'flex-end', alignItems: 'center', width: '100%', marginTop: '0px' }}>

                    <Button
                            
                            onClick={() => handleChange({ target: { value: (bnbBalance / (10 ** 18)).toString() } })}
                            size="small"
                            style={{
                                borderRadius: '25px',
                                paddingTop: '2px',
                                paddingBottom: '2px',
                                paddingRight: '4px',
                                paddingLeft: '4px',
                                fontSize: '14px',
                                fontWeight: 'bold',
                            }}
                            text
                        >
                            Max
                        </Button>
                        {/* <div style={{ marginTop: '2px', padding: '2px', fontSize: '18px', fontWeight: 'normal', color: 'grey' }}>
                           {formatCurrencyExtended((bnbBalance / (10 ** 18)) * bnbPrice)}
                        </div> */}
                        
                    </div>
                </div>
                
                {/* <div style={{ display: 'flex', flexDirection: 'column', height: '100%' }}>
                    <button 
                        style={{
                        flex: 1, 
                        backgroundColor: 'transparent', 
                        border: 'none', 
                        color: 'white', 
                        fontSize: '23px', 
                        fontWeight: 'bold',
                        cursor: 'pointer',
                        border: '3px solid white'
                        }}
                        onMouseOver={(e) => e.target.style.opacity = '0.7'}
                        onMouseOut={(e) => e.target.style.opacity = '1'}
                        //onMouseDown={(e) => { e.target.style.transform = 'scale(0.95)'; startStepping('up')}}
                        //onMouseUp={(e) => {e.target.style.transform = 'scale(1)' ; stopStepping()}}
                        onClick={() => handleStep('up')}
                        onMouseDown={() => setDirection('up')}
                        onMouseUp={() => setDirection(null)}
                        onMouseLeave={() => setDirection(null)}
                    >
                        +
                    </button>
                    <button
                        style={{
                        flex: 1,
                        backgroundColor: 'transparent', 
                        border: 'none', 
                        color: 'white', 
                        fontSize: '23px', 
                        fontWeight: 'bold',
                        cursor: 'pointer',
                        border: '3px solid white'
                        }}
                        onMouseOver={(e) => e.target.style.opacity = '0.7'}
                        onMouseOut={(e) => e.target.style.opacity = '1'}
                        //onMouseDown={(e) => { e.target.style.transform = 'scale(0.95)'; startStepping('down')}}
                        //onMouseUp={(e) => {e.target.style.transform = 'scale(1)' ; stopStepping()}}
                        onClick={() => handleStep('down')}
                        onMouseDown={() => setDirection('down')}
                        onMouseUp={() => setDirection(null)}
                        onMouseLeave={() => setDirection(null)}
                    >
                        -
                    </button>
                    </div> */}
            </div>

            <div style={{...miniCardHeaderStyle, marginBottom: '5px'}}>
                    Token Out
                </div>
            <div style={{
                display: 'flex', 
                flexDirection: 'row', 
                alignItems: 'center', 
                justifyContent: 'space-between', 
                width: '100%',
                //border: '1px solid black',
                borderRadius: '25px',
                backgroundColor: 'black',
                padding: '15px',
                overflow: 'hidden'  // Prevents overflow
            }}>
                {/* Left Container: Image + Input */}
                <div style={{flex: 0.75, paddingRight: '5px'}}> {/* Added flex and padding */}
                <div style={{ display: 'flex', flexDirection: 'row', alignItems: 'center',  position: 'relative'}}>
                    <div>
                        <img src={imageSrcTo} alt={altText} style={{ width: '40px', height: '40px', marginRight: '5px', border: '2px solid white', borderRadius: '50%'
                        }} />
                        <img src={imageSrc} alt={altText} style={{ position: 'absolute', bottom: '0', left: '0', width: '25px', height: '25px', border: '2px solid white', borderRadius: '50%'}} />
                    </div>
                    <div style={{ position: 'flex', flexDirection: 'column', alignItems: 'flex-start', flex: 1, width: '100%'}}>
                    {/* <input type="text" value={ formatDecimals(tokensOutWithTokenomics, 9)} onChange={handleChange} placeholder="Amount" disabled={true}
                            style={{ width: '100%', border: 'none', outline: 'none', backgroundColor: 'transparent', fontSize: '18px', fontWeight: '100', color: 'white'}} /> */}

                                <div style={{
                                width: '100%',
                                fontSize: '18px',
                                fontWeight: '100',
                                color: 'white'
                                }}>
                                {formatDecimals(tokensOutWithTokenomics ? tokensOutWithTokenomics : 0, 9)}
                                </div>
                                    <div style={{ marginTop: '1px', padding: '1px', fontSize: '14px', fontWeight: 'normal', color: 'grey' }}>
                           {formatCurrencyExtended( tokensOutWithTokenomics ? tokensOutWithTokenomics / 10 ** 9 * rocketFiPrice : 0)}
                        </div>
                        </div>
                </div>
                </div>
                {/* Right Container */}
                <div style={{
                    display: 'flex',
                    flexDirection: 'column',
                    alignItems: 'flex-end',
                    flex: 0.25,  // takes up 50% of the space
                }}>
                    {/* Select Token Button */}
                    <div style={{ display: 'flex', flexDirection: 'column', justifyContent: 'flex-end', alignItems: 'flex-end', width: '100%', marginTop: '5px' }}>
                    <Button
                        rounded
                        severity="warning"
                        //onClick={() => setTokenSelectorVisible(true)}
                        size="small"
                        outlined
                        style={{
                            borderRadius: '25px',
                            paddingBottom: '2px',
                            paddingTop: '2px',
                            paddingLeft: '8px',
                            paddingRight: '8px',
                            fontSize: '14px',
                            fontWeight: 'bold',
                        }}
                    >
                        ROCKETFI
                    </Button>
                    <div style={{ marginTop: '2px', padding: '2px', fontSize: '14px', fontWeight: '100', color: 'grey', 
                    width: '100%', textAlign: 'right'
                }}>
                            Bal: {formatDecimals(data?.contractData?.tokenData?.rocketFiBalance, 9)}
                        </div>
                        <div style={{ display: 'flex', flexDirection: 'column', justifyContent: 'flex-end', alignItems: 'flex-end', width: '100%'}}>
                        <div style={miniCardHeaderStyle}>
                            {data?.contractData?.playData
                                ? 'swap fee'
                                : <LoadingTitle />
                            }
                        </div>
                        <div style={{...miniInfoStyle, fontSize:'14px'}}>
                            {data?.contractData?.playData
                                ? formatPercentage(parseFloat(fee)/ 10000)
                                : <LoadingContent />}
                        </div>
                    </div>

                    </div>
                    {/* Token Balance + Max Button */}
                    <div style={{ display: 'flex', flexDirection: 'row', justifyContent: 'flex-end', alignItems: 'center', width: '100%', marginTop: '0px' }}>

                    {/* <Button
                            
                            onClick={() => handleChange({ target: { value: (bnbBalance / (10 ** 18)).toString() } })}
                            size="small"
                            style={{
                                borderRadius: '25px',
                                paddingTop: '2px',
                                paddingBottom: '2px',
                                paddingRight: '4px',
                                paddingLeft: '4px',
                                fontSize: '14px',
                                fontWeight: 'bold',
                            }}
                            text
                        >
                            Max
                        </Button> */}
                        {/* <div style={{ marginTop: '2px', padding: '2px', fontSize: '18px', fontWeight: 'normal', color: 'grey' }}>
                           {formatCurrencyExtended((bnbBalance / (10 ** 18)) * bnbPrice)}
                        </div> */}
                        
                    </div>
                </div>
                
            </div>

                        
           
        </div>
        <div style={{
            alignContent: 'flex-end'
        }}>
              <div style={{ marginTop: '10px', width: '100%', position: 'relative' }}>
                <InputText 
                    type="text" 
                    value={smartCode} 
                    onChange={handleSmartCodeInputChange} 
                    className="p-inputtext-sm" 
                    placeholder="Smart Code Referral" 
                    style={{ width: '100%', paddingRight: '30px' }} // Add padding to prevent text overlap with icon
                />
                <i 
                    className={isValid && smartCodeData?.smartCode !== smartCode ? "pi pi-check" : smartCode !== '' ? "pi pi-times" : ''}
                    style={{
                        position: 'absolute',
                        right: '10px',
                        top: '50%',
                        transform: 'translateY(-50%)',
                        color: isValid && smartCodeData?.smartCode !== smartCode  ? 'green' : 'red'
                    }}
                />
            </div>
            {
                smartCodeData?.smartCode === smartCode && smartCodeData?.smartCode !== '' &&
                <div style={{marginTop: '10px'}}><Message severity="warn" text="Using the connected account's Smart Code is not supported." /></div>
            }
             {
                smartCode && smartCode !== ''  && !isValid &&
                <div style={{marginTop: '10px'}}><Message severity="warn" text="Invalid Code. Regular swapper will be used." /></div>
            }
            </div>
        {/* {
            isSwapping ? <div style={{  width: '100%', justifyContent: 'center', marginTop: '10px' }}><Progress
            indeterminated
            color="gradient"
            status="secondary"
            size="xl"

          /></div> : <>
           <Button
                    rounded
                    severity="warning"
                    onClick={() => {handleSwap(value).then((success) => {
                    if (success) {
                        setValue('');
                        setDisplayValue('');
                        setTokensOut(0);
                    }
                    })}}
                    size="small"
                    style={{ width: '100%', justifyContent: 'center', marginTop: '10px' }}
                    disabled = {!(tokensOutWithTokenomics > 0) || swapper === null || swapper === undefined || swapper === '' || swapper==="0x0000000000000000000000000000000000000000" || smartCodeData?.smartCode === smartCode }
                >
                    Swap
                </Button>

               
                
          </>} */}
          <div style={{marginTop: '20px'}}>
          <Card title={
                                    data?.contractData?.burnData !== undefined
                                        ? <div style={{ fontSize: '16px', }}>Swap Rewards Available</div>
                                        : <Skeleton width="70%" height="25px" className="mb-2" />
                                }
                                    style={rewardCardStyle}>

                                    <div style={{ display: 'flex', justifyContent: 'space-between', alignItems: 'center' }}>
                                        <div>
                                            <div style={{...miniInfoStyle, fontSize:'24px'}}>
                                                {data?.contractData
                                                    ? formatBalanceWithIcon(data?.contractData?.playData?.buyBoostAvailable, "0x6e61579c22F9a6dA63a33e819f29B6697d2a126E", data?.dbData, 9)
                                                    : <LoadingContent />}
                                            </div>
                                            <div style={{ fontSize: "12px" }}>
                                                {data?.contractData?.playData
                                                    ? formatCurrencyExtended((data?.contractData?.playData?.buyBoostAvailable / (10 ** 9)) * rocketFiPrice)
                                                    : <LoadingTitle />}
                                            </div>
                                        </div>

                                        
                                    </div>
                                  
             </Card>

             <div style={{ display: 'flex', justifyContent: 'center', alignItems: 'center', marginBottom: '20px'}}>
                                        {
                                            isSwapping ? <div style={{  width: '200px', justifyContent: 'center', marginTop: '10px', marginLeft: '10px',
                                            marginRight: '10px',
                                        }}><Progress
                                            indeterminated
                                            color="gradient"
                                            status="secondary"
                                            size="xl"

                                        /></div> : <>
                                        <Button
                                                    rounded
                                                    severity="warning"
                                                    onClick={() => {handleSwap(value).then((success) => {
                                                    if (success) {
                                                        setValue('');
                                                        setDisplayValue('');
                                                        setTokensOut(0);
                                                    }
                                                    })}}
                                                    size="small"
                                                    style={{
                                                        justifyContent: 'center',
                                                        marginTop: '10px',
                                                        alignSelf: 'flex-end', // Adjusts the vertical alignment
                                                        width: '200px',
                                                        justifyContent: 'center',
                                                        marginLeft: '10px',
                                                        marginRight: '10px',
                                                    }}
                                                    disabled = {!(tokensOutWithTokenomics > 0) || swapper === null || swapper === undefined || swapper === '' || swapper==="0x0000000000000000000000000000000000000000" || bnbBalance<1 || bnbBalance==='' || (smartCodeData?.smartCode === smartCode && smartCodeData?.smartCode !== '') }
                                                >
                                                    Swap
                                                </Button>

                                            
                                                
                                        </>}
                                        </div>

             <Card title={
                                    data?.contractData?.burnData !== undefined
                                        ? <div style={{ fontSize: '16px', }}>Swap Play Info</div>
                                        : <Skeleton width="70%" height="25px" className="mb-2" />
                                }
                                    style={rewardCardStyle}>

                                    <div style={{ display: 'grid', gridTemplateColumns: 'repeat(auto-fill, minmax(115px, 1fr))', gap: '10px', marginTop: '10px' }}>

                                        <div>
                                            <div style={miniCardHeaderStyle}>
                                                {data?.contractData
                                                    ? 'Reward Chance'
                                                    : <LoadingTitle />
                                                }
                                            </div>
                                          { data?.contractData?.playData?.rocketTokens > 0 ?
                                            <div style={miniInfoStyle}>
                                            {data?.contractData
                                                ? <span>{formatPercentage(parseFloat(data?.contractData?.playData?.yourPoolChanceBuy) / 10000) } {
                                                    <div style={{fontWeight: 'normal', fontSize: '12px'
                                                    }}>
                                                    {'('}2x Applied{')'}
                                                    </div>}</span>
                                                : <LoadingContent />}
                                        </div>
                                          :
                                           <div style={miniInfoStyle}>
                                                {data?.contractData
                                                    ? formatPercentage(parseFloat(data?.contractData?.playData?.yourPoolChanceBuy) / 10000)
                                                    : <LoadingContent />}
                                            </div>
                                            }
                                        </div>
                                        <div>
                                            <div style={miniCardHeaderStyle}>
                                                {data?.contractData
                                                    ? '2x Multipliers'
                                                    : <LoadingTitle />
                                                }
                                            </div>
                                            <div style={miniInfoStyle}>
                                                {data?.contractData
                                                    ? data?.contractData?.playData?.rocketTokens
                                                    : <LoadingContent />}
                                            </div>
                                        </div>

                                        <div>
                                            <div style={miniCardHeaderStyle}>
                                                {data?.contractData
                                                    ? 'Minimum Tokens Required to Qualify'
                                                    : <LoadingTitle />
                                                }
                                            </div>
                                            <div style={miniInfoStyle}>
                                                {data?.contractData
                                                    ? formatBalanceWithIcon(data?.contractData?.playData?.rocketFiRequiredForRollingBuyBoost, "0x6e61579c22F9a6dA63a33e819f29B6697d2a126E", data?.dbData, 9)
                                                    : <LoadingContent />}
                                            </div>
                                            <div style={{ fontSize: "12px" }}>
                                                {data?.contractData?.playData
                                                    ? formatCurrencyExtended((data?.contractData?.playData?.rocketFiRequiredForRollingBuyBoost / (10 ** 9)) * rocketFiPrice)
                                                    : <LoadingTitle />}
                                            </div>
                                        </div>

                                    </div>
                                </Card>
                                <Card title={
                                    data?.contractData?.burnData !== undefined
                                        ? <div style={{ fontSize: '16px', }}>Previously Rewarded</div>
                                        : <Skeleton width="70%" height="25px" className="mb-2" />
                                }
                                    style={rewardCardStyle}>

                                    <div style={{ display: 'grid', gridTemplateColumns: 'repeat(auto-fill, minmax(115px, 1fr))', gap: '10px', marginTop: '10px' }}>

                                        <div>
                                            <div style={miniCardHeaderStyle}>
                                                {data?.contractData
                                                    ? 'Last Swap Reward Amount'
                                                    : <LoadingTitle />
                                                }
                                            </div>
                                            <div style={miniInfoStyle}>
                                                {data?.contractData
                                                    ? formatBalanceWithIcon(data?.contractData?.playData?.lastBuyBoostWonAmount, "0x6e61579c22F9a6dA63a33e819f29B6697d2a126E", data?.dbData, 9)
                                                    : <LoadingContent />}
                                            </div>
                                            <div style={{ fontSize: "12px" }}>
                                                {data?.contractData?.playData?.lastBuyBoostWonAmount
                                                    ? formatCurrencyExtended((data?.contractData?.playData?.lastBuyBoostWonAmount / (10 ** 9)) * rocketFiPrice)
                                                    : <LoadingTitle />}
                                            </div>
                                        </div>
                                        <div>
                                            <div style={miniCardHeaderStyle}>
                                                {data?.contractData
                                                    ? 'Last Wallet Rewarded'
                                                    : <LoadingTitle />
                                                }
                                            </div>
                                            <div style={miniInfoStyle}>
                                                {data?.contractData?.playData?.lastBuyBoostWinner
                                                    ? formatWalletAddress(data?.contractData?.playData?.lastBuyBoostWinner)
                                                    : <LoadingContent />}
                                            </div>
                                        </div>



                                    </div>
                                </Card>
             </div>
           
        </>
    );
  };


